import { Component } from 'react';
import { connect } from 'react-redux';

import { checkDifferent } from 'utils/formHandlers';
import { twclsx } from 'utils/twclsx';

import { BackgroundType, RootState } from '../../types';

interface AttributionProps {
    backgrounds: BackgroundType[];
}

interface AttributionState {
    background: BackgroundType | null;
}

class Attribution extends Component<AttributionProps, AttributionState> {
    constructor(props: AttributionProps) {
        super(props);
        this.state = {
            background: null,
        };
    }

    static getDerivedStateFromProps(props: AttributionProps, state: AttributionState) {
        if (
            checkDifferent(
                state.background,
                props.backgrounds.find((x) => {
                    return x.status === 'active';
                })
            )
        ) {
            return {
                background: props.backgrounds.find((x) => {
                    return x.status === 'active';
                }),
            };
        }

        return null;
    }

    render() {
        return (
            <div
                className={twclsx(
                    'fixed',
                    'z-20',
                    'mr-3',
                    'mb-1',
                    'right-0',
                    'bottom-0',
                    'text-sm',
                    this.state.background?.text === 'dark' ? 'text-black' : 'text-white'
                )}
                dangerouslySetInnerHTML={{
                    __html: this.state.background?.attribution || '',
                }}
            />
        );
    }
}

const attributionStateToProps = (state: RootState) => ({});

const attributionDispatchToProps = () => ({});

export default connect(attributionStateToProps, attributionDispatchToProps)(Attribution);
